import { useEffect, useState } from 'react';
import styles from '@components/DevToolbar/DevToolbarTab/DevToolbarTabCache/DevToolbarTabCache.styles';
import commonStyles from '@components/DevToolbar/DevToolbarTab/common.styles';
import DevToolbarTabHeader from '@components/DevToolbar/DevToolbarTab/DevToolbarTabHeader/DevToolbarTabHeader';
import { IDevToolbarProps } from '@components/DevToolbar/typescript';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import cacheService from '@components/DevToolbar/services/cacheService';
type PropsType = {
  devProps: IDevToolbarProps | null;
};
const DevToolbarTabCache = ({
  devProps
}: PropsType) => {
  const [cacheTimeLeft, setCacheTimeLeft] = useState(devProps?.expireDate ? Math.ceil((devProps.expireDate - new Date().getTime()) / 1000) : 0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCacheTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [cacheTimeLeft]);
  useEffect(() => {
    setCacheTimeLeft(devProps?.expireDate ? Math.ceil((devProps.expireDate - new Date().getTime()) / 1000) : 0);
  }, [devProps]);
  if (!devProps) {
    return <div sx={commonStyles.toolbarTab}>
        <DevToolbarTabHeader name="Cache Information" />
        <div>
          <Heading h={4} headingType={1} pb={24} bold align="center" color="white">
            No cache information available
          </Heading>
        </div>
      </div>;
  }
  const {
    pageType
  } = devProps;
  const handleClearCache = async () => {
    const path = window.location.pathname;
    await cacheService.revalidatePath(path);
    setCacheTimeLeft(0);
    window.location.reload();
  };
  const handleChangeCache = () => {
    alert('Work in progress');
  };
  return <div sx={commonStyles.toolbarTab}>
      <DevToolbarTabHeader name="Cache Information" />

      <div sx={commonStyles.miniHeading}>Information</div>
      <div sx={commonStyles.badges}>
        {pageType === 'static' && <div sx={commonStyles.badge()}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="WatchLater" size="16px" color="white" />
            </div>
            Cache time: {cacheTimeLeft < 0 ? <b>{`expired for ${cacheTimeLeft * -1}s`}</b> : <b>{cacheTimeLeft}s</b>}
          </div>}
        <div sx={commonStyles.badge()}>
          <div sx={commonStyles.badgeIcon}>
            <Icon icon="HelpOutline" size="16px" color="white" />
          </div>
          Page type: <b>{pageType}</b>
        </div>
      </div>

      <div sx={commonStyles.miniHeading}>Manage cache</div>
      {pageType === 'static' && <>
          <div sx={styles.section}>
            <Button variant="outlined" variantColor="white" size="small" onClick={() => handleClearCache()}>
              Clear cache
            </Button>
          </div>
          <div sx={styles.section}>
            <input type="number" value={500} name="cacheTime" />
            <Button variant="outlined" variantColor="white" size="small" onClick={() => handleChangeCache()}>
              Set page cache time
            </Button>
          </div>
        </>}
      {pageType === 'dynamic' && <div sx={styles.section}>
          <div>
            <Heading h={4} headingType={4} pb={24} bold align="center" color="white">
              Cache management is not available for dynamic pages
            </Heading>
          </div>
        </div>}
    </div>;
};
export default DevToolbarTabCache;